import { financeFetcher } from './fetcher';

export const createBankAccount = (financeEntityId, data) => {
    return financeFetcher
        .post('/bank_accounts/', {
            data: {
                ...data,
                finance_entity_id: financeEntityId
            }
        })
        .then(({ response }) => response);
};

export const updateBankAccount = (id, data) => {
    return financeFetcher.put(`/bank_accounts/${id}`, { data }).then(({ response }) => response);
};

export const deleteBankAccount = id => {
    return financeFetcher.delete(`/bank_accounts/${id}`);
};
